import * as React from 'react'

export default class extends React.Component{

    render(){
        return (
            <div className="container pt-4">
                { this.props.children }
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/container.tsx